import { Attribute } from "./attribute";
import { Collection } from "./collection";
import { FabricObject } from "./fabric";
import { Finish } from "./finish";
import { PriceUmbrella } from "../pricing/price";
import { ProductSpecs } from "./product";

export interface UmbrellaModel {
  _id: string;
  model: string;
  display_name: string;
  finishes: Finish[];
  dv?: boolean;
  size?: string;
  /**
   * The API returns canopy shape as a string array (e.g. ["round"],
   * ["square"], ["rectangle"]). Treated as the canonical shape source
   * across the app; `shape[0]` is the primary shape.
   */
  shape?: string[];
  line_art_url?: string;
  product_lines?: Collection;
  price?: PriceUmbrella;
  image?: string;
  attributes: any;
  specs: ProductSpecs[];
  other_specs?: ProductSpecs[];
}

export enum UmbrellaType {
  Cantilever = "cantilever",
  Giant = "giant",
  Market = "market",
  Beach = "beach",
  Patio = "patio"
}
